function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable @typescript-eslint/no-explicit-any */
import { css } from 'styled-components';
export var isInteger = function isInteger(value) {
  return parseFloat(value) === parseInt(value, 10);
};
export var calculatePercentageGridValue = function calculatePercentageGridValue(value, gridSize) {
  return "".concat(100 / gridSize * value, "%");
};
export var getMinWidthMedia = function getMinWidthMedia(breakpoint) {
  return function () {
    return css(["@media (min-width:", "px){", "}"], breakpoint, css.apply(void 0, arguments));
  };
};
export var getMaxWidthMedia = function getMaxWidthMedia(breakpoint) {
  return function () {
    return css(["@media (max-width:", "px){", "}"], breakpoint - 1, css.apply(void 0, arguments));
  };
};
export var getLimitedMedia = function getLimitedMedia(breakpoints, current, currentIndex) {
  return currentIndex !== Object.keys(breakpoints).length - 1 ? "(min-width: ".concat(breakpoints[current], "px) and (max-width: ").concat(breakpoints[Object.keys(breakpoints)[currentIndex + 1]] - 1, "px)") : "(min-width: ".concat(breakpoints[current], "px)");
};
export var mediaQueryFunctionsList = function mediaQueryFunctionsList(breakpoints) {
  return Object.keys(breakpoints).reduce(function (media, breakpoint, index) {
    var newMedia = _objectSpread({}, media);

    newMedia[breakpoint] = index === 0 ? function () {
      return css.apply(void 0, arguments);
    } : function () {
      return css(["@media (min-width:", "px){", "}"], breakpoints[breakpoint], css.apply(void 0, arguments));
    };
    return newMedia;
  }, {});
};
export var mediaQueryFunctionsListWithLimits = function mediaQueryFunctionsListWithLimits(breakpoints) {
  return Object.keys(breakpoints).reduce(function (media, breakpoint, index) {
    var newMedia = _objectSpread({}, media);

    newMedia[breakpoint] = function () {
      return css(["@media ", "{", "}"], getLimitedMedia(breakpoints, breakpoint, index), css.apply(void 0, arguments));
    };

    return newMedia;
  }, {});
};